
import { Injectable } from '@angular/core';
import { SiriusServiceBase, SiriusDataService } from '@ibtech/sirius-angular-service';

import { LiveProcessRequest } from '../shared/models/process.model';

@Injectable()
export class InnerMenuLiveProcessService extends SiriusServiceBase {
    constructor() {
        super();
    }
    getUserLiveProcess(dataService: SiriusDataService, liveProcessRequest: LiveProcessRequest) {
        return dataService.post("GetUserLiveProcess", liveProcessRequest);
    }
}
